import React, { useRef, useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Button, Typography, Tooltip } from "@material-ui/core";
import { validateLogoFile, VALID_TYPES } from "./validateLogoFile";
import { useLogoUploadStyles } from "./styles";

const ACCEPT_TYPES = VALID_TYPES.join(", ");
const TOOLTIP_TEXT =
  "We recommend using a 200x200 pixel PNG or SVG formatted logo image file that is not larger than 1mb.";

const LogoUpload = ({ onLogoChange, initialPreview }) => {
  const classes = useLogoUploadStyles();
  const inputElement = useRef(null);
  const [preview, setPreview] = useState(initialPreview || null);
  const [error, setError] = useState("");

  useEffect(() => {
    if (initialPreview) {
      setPreview(initialPreview);
    }
  }, [initialPreview]);

  const handleFileSelected = (event) => {
    if (event.target.files.length === 0) return;

    const file = event.target.files[0];
    const result = validateLogoFile(file);

    if (!result?.valid) {
      setPreview(null);
      setError(result?.error);
      onLogoChange(null);
      event.target.value = "";
      return;
    }

    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (e) => {
      setPreview(e.target.result);
      setError("");
      onLogoChange({
        encodedImage: e.target.result.split(",")[1],
        imageExtension: file.name.split(".").pop(),
        file,
      });
    };

    event.target.value = "";
  };

  return (
    <div className={classes.wrapper}>
      <div className={`${classes.previewBox} logo-preview-box`}>
        {preview ? (
          <img
            src={preview}
            alt="Logo preview"
            className={`${classes.previewImage} logo-preview`}
          />
        ) : (
          <>
            <span className={classes.placeholderIcon}>P</span>
            <Typography className={classes.placeholderText}>
              Parking Rewards
            </Typography>
          </>
        )}
      </div>
      <Tooltip arrow title={TOOLTIP_TEXT}>
        <Button
          color="primary"
          variant="contained"
          className={`${classes.logoButton} logo-upload-button`}
          onClick={() => inputElement.current.click()}
        >
          LOGO
        </Button>
      </Tooltip>
      <input
        type="file"
        name="logouploadfile"
        id="logouploadfile"
        className="logo-upload-file"
        onChange={handleFileSelected}
        ref={inputElement}
        accept={ACCEPT_TYPES}
        style={{ display: "none" }}
      />
      {error && (
        <Typography color="error" className={`${classes.error} logo-upload-error`}>
          {error}
        </Typography>
      )}
    </div>
  );
};

LogoUpload.defaultProps = {
  onLogoChange: () => {},
  initialPreview: null,
};

LogoUpload.propTypes = {
  onLogoChange: PropTypes.func,
  initialPreview: PropTypes.string,
};

export default LogoUpload;
